import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
    table: {
        fontSize: '13px',
        color: 'inherit',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        width: '100%',
        minWidth: 0,
        '& .MuiDataGrid-root': {
            flex: 1,
            minHeight: 0,
            width: '100%',
            minWidth: 0,
        },
        '& .MuiDataGrid-columnHeadersInner': {
            background: '#F4F6F8',
        },
        '& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus': {
            outline: 'none !important',
        },
        '& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus': {
            outline: 'none !important',
        },
        '& .MuiDataGrid-virtualScroller': {
            overscrollBehavior: 'contain',
            flex: 1,
            minHeight: 0,
        },
    },
});
